import type { Store } from '@nucleus-commerce/api-client/admin';

/** Where the storefront must serve the key; null until the store has a primary domain. */
export function indexNowKeyLocation(
  store: Pick<Store, 'primaryDomain'>,
  key: string,
): string | null {
  return store.primaryDomain ? `https://${store.primaryDomain}/${key}.txt` : null;
}
